import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import icons from 'assets/icons.svg';

const Container = styled.svg`
  display: inline-block;
  fill: currentColor;
  height: 1em;
  pointer-events: none;
  vertical-align: -0.175em;
  width: 1em;
  ${props => props.size === 'large' && css`
    display: block;
    height: 3.5em;
    width: 2.5em;
  `}
`;

const Icon = class extends React.Component {
  shouldComponentUpdate() {
    return false;
  }
  render() {
    const { id, size, title } = this.props;
    return (
      <Container role="img" title={title} size={size}>
        <use xlinkHref={`${icons}#${id}`} />
      </Container>
    );
  }
};

Icon.defaultProps = {
  size: '',
};

Icon.propTypes = {
  id: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['', 'large']),
  title: PropTypes.string.isRequired,
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/base/Icon.js